// // import React from 'react';

// // const Projects = () => {
// //   const projects = [
// //     {
// //       title: 'The Crown Villas',
// //       location: 'Rameshwar Banda Village, Patancheru Mandal',
// //       area: '8.7 Acres',
// //       units: '125 Villas',
// //       description: 'The Crown Villas project is an 8.7 acre development of 125 exclusive Villas, set in Rameshwar Banda Village, Patancheru Mandal, Sangareddy District. A calm and quiet locale 6 km from Patancheru, and 30 km from Sangareddy.',
// //       features: ['Gated Community', '24/7 Security', 'Clubhouse', 'Swimming Pool', 'Landscaped Gardens', 'Children\'s Play Area'],
// //       image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80',
// //     },
// //     {
// //       title: 'Royal Oak Estates',
// //       location: 'Zaheerabad, NIMZ',
// //       area: '15 Acres',
// //       units: 'Phase 1',
// //       description: 'Royal Oak is a 15 acre development located in Zaheerabad, on the Bidar Road, just 3 km from the National Investment Manufacturing Zone (NIMZ). Strategically positioned for growth and connectivity.',
// //       features: ['Prime Location', 'Near NIMZ', 'Modern Infrastructure', 'Wide Roads', 'Electricity & Water', 'Investment Potential'],
// //       image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
// //     },
// //   ];

// //   return (
// //     <div className="pt-24">
// //       {/* Hero Section */}
// //       <section
// //         className="relative h-[60vh] flex items-center justify-center bg-fixed"
// //         style={{
// //           backgroundImage: `linear-gradient(135deg, rgba(30, 27, 26, 0.8), rgba(88, 79, 66, 0.7)), url('https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=1920&q=80')`,
// //           backgroundSize: 'cover',
// //           backgroundPosition: 'center',
// //         }}
// //       >
// //         <div className="text-center">
// //           <h1 className="font-serif text-5xl lg:text-7xl font-bold text-luxury-white mb-4">
// //             Our Projects
// //           </h1>
// //           <p className="text-xl text-luxury-white/90">
// //             Premium Residential Developments
// //           </p>
// //         </div>
// //       </section>

// //       {/* Projects List */}
// //       <section className="py-20 lg:py-32 bg-luxury-bg">
// //         <div className="container mx-auto px-4 lg:px-8">
// //           {projects.map((project, index) => (
// //             <div
// //               key={index}
// //               className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-32 last:mb-0 ${
// //                 index % 2 === 1 ? 'lg:grid-flow-dense' : ''
// //               }`}
// //             >
// //               {/* Image */}
// //               <div className={`relative ${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
// //                 <div className="relative overflow-hidden rounded shadow-2xl">
// //                   <img
// //                     src={project.image}
// //                     alt={project.title}
// //                     className="w-full h-[500px] object-cover hover:scale-110 transition-transform duration-700"
// //                   />
// //                   <div className="absolute -bottom-5 -left-5 w-full h-full border-4 border-luxury-accent pointer-events-none" />
// //                 </div>
// //               </div>

// //               {/* Content */}
// //               <div className={index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}>
// //                 <span className="inline-block text-sm font-semibold uppercase tracking-[0.15em] text-luxury-accent mb-4">
// //                   Featured Project
// //                 </span>
// //                 <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-4">
// //                   {project.title}
// //                 </h2>
// //                 <p className="text-luxury-primary text-lg mb-6">{project.location}</p>

// //                 {/* Stats */}
// //                 <div className="flex gap-8 mb-6">
// //                   <div>
// //                     <div className="font-serif text-3xl font-bold text-luxury-accent">{project.area}</div>
// //                     <div className="text-sm text-luxury-secondary uppercase tracking-wider">Total Area</div>
// //                   </div>
// //                   <div>
// //                     <div className="font-serif text-3xl font-bold text-luxury-accent">{project.units}</div>
// //                     <div className="text-sm text-luxury-secondary uppercase tracking-wider">Units</div>
// //                   </div>
// //                 </div>

// //                 <p className="text-lg text-luxury-primary leading-relaxed mb-8">
// //                   {project.description}
// //                 </p>

// //                 {/* Features */}
// //                 <div className="mb-8">
// //                   <h3 className="font-serif text-xl font-semibold text-luxury-dark mb-4">Key Features</h3>
// //                   <div className="grid grid-cols-2 gap-3">
// //                     {project.features.map((feature, idx) => (
// //                       <div key={idx} className="flex items-center gap-2">
// //                         <svg className="w-5 h-5 text-luxury-accent flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
// //                           <path
// //                             fillRule="evenodd"
// //                             d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
// //                             clipRule="evenodd"
// //                           />
// //                         </svg>
// //                         <span className="text-luxury-primary">{feature}</span>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 </div>

// //                 <a
// //                   href="/contact"
// //                   className="inline-block px-8 py-4 bg-luxury-accent text-luxury-white font-medium uppercase tracking-wider rounded hover:bg-luxury-primary transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
// //                 >
// //                   Inquire Now
// //                 </a>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default Projects;




// import React, { useEffect, useRef, useState } from 'react';

// const Projects = () => {
//   const [revealedElements, setRevealedElements] = useState(new Set());
//   const observerRef = useRef(null);

//   const projects = [
//     {
//       title: 'The Crown Villas',
//       location: 'Rameshwar Banda Village, Patancheru Mandal',
//       area: '8.7 Acres',
//       units: '125 Villas',
//       description: 'The Crown Villas project is an 8.7 acre development of 125 exclusive Villas, set in Rameshwar Banda Village, Patancheru Mandal, Sangareddy District. A calm and quiet locale 6 km from Patancheru, and 30 km from Sangareddy.',
//       features: ['Gated Community', '24/7 Security', 'Clubhouse', 'Swimming Pool', 'Landscaped Gardens', 'Children\'s Play Area'],
//       image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80',
//     },
//     {
//       title: 'Royal Oak Estates',
//       location: 'Zaheerabad, NIMZ',
//       area: '15 Acres',
//       units: 'Phase 1',
//       description: 'Royal Oak is a 15 acre development located in Zaheerabad, on the Bidar Road, just 3 km from the National Investment Manufacturing Zone (NIMZ). Strategically positioned for growth and connectivity.',
//       features: ['Prime Location', 'Near NIMZ', 'Modern Infrastructure', 'Wide Roads', 'Electricity & Water', 'Investment Potential'],
//       image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
//     },
//   ];

//   useEffect(() => {
//     observerRef.current = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setRevealedElements((prev) => new Set([...prev, entry.target.dataset.reveal]));
//           }
//         });
//       },
//       { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
//     );

//     const elements = document.querySelectorAll('[data-reveal]');
//     elements.forEach((el) => observerRef.current.observe(el));

//     return () => {
//       if (observerRef.current) {
//         observerRef.current.disconnect();
//       }
//     };
//   }, []);

//   const isRevealed = (id) => revealedElements.has(id);

//   return (
//     <div className="pt-24 bg-luxury-bg">
//       {/* Premium Hero Section */}
//       <section className="relative h-[75vh] flex items-center justify-center overflow-hidden">
//         {/* Animated Background */}
//         <div
//           className="absolute inset-0 bg-cover bg-center bg-fixed"
//           style={{
//             backgroundImage: `url('https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=1920&q=80')`,
//           }}
//         />
        
//         {/* Luxury Gradient Overlays */}
//         <div className="absolute inset-0 bg-gradient-to-br from-luxury-dark/90 via-luxury-primary/80 to-luxury-accent/70" />
//         <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/60 via-transparent to-transparent" />
        
//         {/* Shimmer Effect */}
//         <div className="absolute inset-0 opacity-30">
//           <div className="absolute top-0 -left-full h-full w-1/2 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 animate-[shimmer_3s_ease-in-out_infinite]" />
//         </div>

//         {/* Decorative Elements */}
//         <div className="absolute top-20 left-10 w-32 h-32 border-2 border-luxury-accent/30 rounded-full animate-pulse" />
//         <div className="absolute bottom-20 right-10 w-48 h-48 border-2 border-luxury-accent/20 rounded-full animate-pulse delay-75" />

//         <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
//           <div
//             data-reveal="hero-badge"
//             className={`inline-block mb-6 transition-all duration-1000 ${
//               isRevealed('hero-badge')
//                 ? 'opacity-100 translate-y-0'
//                 : 'opacity-0 -translate-y-8'
//             }`}
//           >
//             <span className="inline-block px-6 py-2 border-2 border-luxury-accent/50 rounded-full text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent bg-luxury-dark/30 backdrop-blur-sm">
//               Premium Developments
//             </span>
//           </div>

//           <h1
//             data-reveal="hero-title"
//             className={`font-serif text-6xl lg:text-8xl font-bold text-luxury-white mb-6 transition-all duration-1000 delay-200 ${
//               isRevealed('hero-title')
//                 ? 'opacity-100 translate-y-0'
//                 : 'opacity-0 translate-y-12'
//             }`}
//           >
//             Our
//             <span className="block mt-2 bg-gradient-to-r from-luxury-accent via-yellow-400 to-luxury-accent bg-clip-text text-transparent animate-gradient">
//               Signature Projects
//             </span>
//           </h1>

//           <div
//             data-reveal="hero-divider"
//             className={`flex items-center justify-center gap-4 mb-6 transition-all duration-1000 delay-400 ${
//               isRevealed('hero-divider')
//                 ? 'opacity-100 scale-100'
//                 : 'opacity-0 scale-0'
//             }`}
//           >
//             <div className="h-px w-24 bg-gradient-to-r from-transparent to-luxury-accent" />
//             <div className="w-2 h-2 bg-luxury-accent rounded-full" />
//             <div className="h-px w-24 bg-gradient-to-l from-transparent to-luxury-accent" />
//           </div>

//           <p
//             data-reveal="hero-subtitle"
//             className={`text-xl lg:text-2xl text-luxury-white/90 max-w-3xl mx-auto leading-relaxed transition-all duration-1000 delay-500 ${
//               isRevealed('hero-subtitle')
//                 ? 'opacity-100 translate-y-0'
//                 : 'opacity-0 translate-y-8'
//             }`}
//           >
//             Crafting exceptional residential spaces that redefine luxury living and investment excellence
//           </p>
//         </div>

//         {/* Bottom Fade */}
//         <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-luxury-bg to-transparent" />
//       </section>

//       {/* Projects Section */}
//       <section className="py-24 lg:py-32 relative">
//         {/* Background Pattern */}
//         <div className="absolute inset-0 opacity-5">
//           <div className="absolute inset-0" style={{
//             backgroundImage: `radial-gradient(circle at 2px 2px, rgb(192, 173, 127) 1px, transparent 0)`,
//             backgroundSize: '48px 48px'
//           }} />
//         </div>

//         <div className="container mx-auto px-4 lg:px-8 relative z-10">
//           {/* Section Header */}
//           <div
//             data-reveal="projects-header"
//             className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-1000 ${
//               isRevealed('projects-header')
//                 ? 'opacity-100 translate-y-0'
//                 : 'opacity-0 translate-y-12'
//             }`}
//           >
//             <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
//               Excellence in Real Estate
//             </span>
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
//               Explore Our Portfolio
//             </h2>
//             <div className="w-24 h-1 bg-luxury-accent mx-auto mb-6" />
//             <p className="text-lg text-luxury-primary/80">
//               Each project is meticulously designed to offer unparalleled quality and sophistication
//             </p>
//           </div>

//           {/* Projects Grid */}
//           {projects.map((project, index) => (
//             <div
//               key={index}
//               className="mb-32 last:mb-0"
//             >
//               <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center ${
//                 index % 2 === 1 ? 'lg:grid-flow-dense' : ''
//               }`}>
                
//                 {/* Image Section */}
//                 <div
//                   data-reveal={`project-image-${index}`}
//                   className={`relative group ${index % 2 === 1 ? 'lg:col-start-2' : ''} transition-all duration-1000 ${
//                     isRevealed(`project-image-${index}`)
//                       ? 'opacity-100 translate-x-0'
//                       : index % 2 === 0 ? 'opacity-0 -translate-x-20' : 'opacity-0 translate-x-20'
//                   }`}
//                 >
//                   {/* Main Image Container */}
//                   <div className="relative overflow-hidden rounded-lg shadow-2xl">
//                     {/* Image */}
//                     <div className="relative overflow-hidden">
//                       <img
//                         src={project.image}
//                         alt={project.title}
//                         className="w-full h-[550px] object-cover transform group-hover:scale-110 transition-transform duration-700"
//                       />
//                       {/* Gradient Overlay */}
//                       <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
//                     </div>

//                     {/* Shimmer Effect on Hover */}
//                     <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
//                       <div className="absolute top-0 -left-full h-full w-1/2 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12 group-hover:animate-[shimmer_1.5s_ease-in-out]" />
//                     </div>

//                     {/* Premium Badge */}
//                     <div className="absolute top-6 left-6 px-4 py-2 bg-luxury-accent/90 backdrop-blur-sm rounded-full">
//                       <span className="text-luxury-white text-xs font-semibold uppercase tracking-wider">Premium</span>
//                     </div>
//                   </div>

//                   {/* Decorative Border */}
//                   <div className="absolute -bottom-6 -right-6 w-full h-full border-4 border-luxury-accent/30 rounded-lg pointer-events-none transform group-hover:translate-x-2 group-hover:translate-y-2 transition-transform duration-500" />
                  
//                   {/* Corner Accents */}
//                   <div className="absolute -top-3 -left-3 w-16 h-16 border-t-4 border-l-4 border-luxury-accent" />
//                   <div className="absolute -bottom-3 -right-3 w-16 h-16 border-b-4 border-r-4 border-luxury-accent" />
//                 </div>

//                 {/* Content Section */}
//                 <div
//                   data-reveal={`project-content-${index}`}
//                   className={`${index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''} transition-all duration-1000 delay-200 ${
//                     isRevealed(`project-content-${index}`)
//                       ? 'opacity-100 translate-y-0'
//                       : 'opacity-0 translate-y-12'
//                   }`}
//                 >
//                   {/* Project Number */}
//                   <div className="mb-4">
//                     <span className="font-serif text-6xl font-bold text-luxury-accent/20">
//                       0{index + 1}
//                     </span>
//                   </div>

//                   {/* Badge */}
//                   <div className="inline-block mb-4">
//                     <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.15em] text-luxury-accent">
//                       <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
//                         <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//                       </svg>
//                       Featured Project
//                     </span>
//                   </div>

//                   {/* Title */}
//                   <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-dark mb-4 leading-tight">
//                     {project.title}
//                   </h2>

//                   {/* Location */}
//                   <div className="flex items-start gap-2 text-luxury-primary text-lg mb-8">
//                     <svg className="w-6 h-6 text-luxury-accent mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
//                     </svg>
//                     <span>{project.location}</span>
//                   </div>

//                   {/* Stats Cards */}
//                   <div className="grid grid-cols-2 gap-6 mb-8">
//                     <div className="relative p-6 bg-gradient-to-br from-luxury-dark/5 to-luxury-accent/10 rounded-lg border border-luxury-accent/20 hover:border-luxury-accent/40 transition-all duration-300 group/card overflow-hidden">
//                       <div className="absolute inset-0 bg-gradient-to-br from-luxury-accent/0 to-luxury-accent/10 opacity-0 group-hover/card:opacity-100 transition-opacity duration-300" />
//                       <div className="relative">
//                         <div className="font-serif text-4xl font-bold text-luxury-accent mb-2">{project.area}</div>
//                         <div className="text-sm text-luxury-secondary uppercase tracking-wider">Total Area</div>
//                       </div>
//                     </div>
//                     <div className="relative p-6 bg-gradient-to-br from-luxury-dark/5 to-luxury-accent/10 rounded-lg border border-luxury-accent/20 hover:border-luxury-accent/40 transition-all duration-300 group/card overflow-hidden">
//                       <div className="absolute inset-0 bg-gradient-to-br from-luxury-accent/0 to-luxury-accent/10 opacity-0 group-hover/card:opacity-100 transition-opacity duration-300" />
//                       <div className="relative">
//                         <div className="font-serif text-4xl font-bold text-luxury-accent mb-2">{project.units}</div>
//                         <div className="text-sm text-luxury-secondary uppercase tracking-wider">Units</div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Description */}
//                   <p className="text-lg text-luxury-primary leading-relaxed mb-10 border-l-4 border-luxury-accent/30 pl-6">
//                     {project.description}
//                   </p>

//                   {/* Features */}
//                   <div className="mb-10">
//                     <h3 className="font-serif text-2xl font-semibold text-luxury-dark mb-6 flex items-center gap-3">
//                       <span className="w-12 h-px bg-luxury-accent" />
//                       Key Features
//                     </h3>
//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                       {project.features.map((feature, idx) => (
//                         <div
//                           key={idx}
//                           className="flex items-center gap-3 group/feature"
//                         >
//                           <div className="flex-shrink-0 w-8 h-8 rounded-full bg-luxury-accent/10 flex items-center justify-center group-hover/feature:bg-luxury-accent/20 transition-colors duration-300">
//                             <svg className="w-5 h-5 text-luxury-accent" fill="currentColor" viewBox="0 0 20 20">
//                               <path
//                                 fillRule="evenodd"
//                                 d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
//                                 clipRule="evenodd"
//                               />
//                             </svg>
//                           </div>
//                           <span className="text-luxury-primary font-medium group-hover/feature:text-luxury-dark transition-colors duration-300">
//                             {feature}
//                           </span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>

//                   {/* CTA Button */}
//                   <div className="flex gap-4">
//                     <a
//                       href="/contact"
//                       className="relative inline-flex items-center gap-3 px-10 py-5 bg-luxury-accent text-luxury-white font-semibold uppercase tracking-wider rounded-lg overflow-hidden group/btn transition-all duration-300 hover:shadow-2xl hover:shadow-luxury-accent/30"
//                     >
//                       <span className="absolute inset-0 bg-gradient-to-r from-luxury-accent to-yellow-600 translate-x-full group-hover/btn:translate-x-0 transition-transform duration-500" />
//                       <span className="relative">Inquire Now</span>
//                       <svg className="relative w-5 h-5 group-hover/btn:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
//                       </svg>
//                     </a>
//                   </div>
//                 </div>
//               </div>

//               {/* Divider */}
//               {index < projects.length - 1 && (
//                 <div className="mt-32 flex items-center justify-center">
//                   <div className="w-full max-w-md h-px bg-gradient-to-r from-transparent via-luxury-accent/30 to-transparent" />
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Call to Action Section */}
//       <section
//         data-reveal="cta-section"
//         className={`py-24 relative overflow-hidden transition-all duration-1000 ${
//           isRevealed('cta-section')
//             ? 'opacity-100 translate-y-0'
//             : 'opacity-0 translate-y-12'
//         }`}
//       >
//         <div className="absolute inset-0 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark" />
//         <div className="absolute inset-0 opacity-20">
//           <div className="absolute inset-0" style={{
//             backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C0AD7F' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
//           }} />
//         </div>

//         <div className="container mx-auto px-4 lg:px-8 relative z-10">
//           <div className="max-w-4xl mx-auto text-center">
//             <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-white mb-6">
//               Ready to Find Your Perfect Investment?
//             </h2>
//             <p className="text-xl text-luxury-white/90 mb-10 leading-relaxed">
//               Connect with our experts to explore these premium developments and discover the ideal property for your portfolio
//             </p>
//             <a
//               href="/contact"
//               className="inline-flex items-center gap-3 px-12 py-6 bg-luxury-white text-luxury-dark font-bold uppercase tracking-wider rounded-lg hover:bg-luxury-accent hover:text-luxury-white transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl"
//             >
//               Schedule a Consultation
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
//               </svg>
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Add Custom Styles */}
//       <style jsx>{`
//         @keyframes shimmer {
//           0% {
//             transform: translateX(-100%) skewX(-12deg);
//           }
//           100% {
//             transform: translateX(200%) skewX(-12deg);
//           }
//         }

//         @keyframes gradient {
//           0%, 100% {
//             background-position: 0% 50%;
//           }
//           50% {
//             background-position: 100% 50%;
//           }
//         }

//         .animate-gradient {
//           background-size: 200% auto;
//           animation: gradient 3s ease infinite;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Projects;

import React, { useEffect, useRef, useState } from 'react';

// RevealImage Component with Silver Shimmer Effect
const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

// RevealContent Component for Text/Content
const RevealContent = ({ children, className = "", delay = 0 }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[60px]'
      } ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

const Projects = () => {
  const projects = [
    {
      title: 'The Crown Villas',
      location: 'Rameshwar Banda Village, Patancheru Mandal',
      area: '8.7 Acres',
      units: '131 Villas',
      description: 'The Crown Villas project is an 8.7 acre development of 131 exclusive Villas, set in Rameshwar Banda Village, Patancheru Mandal, Sangareddy District. A calm and quiet locale 6 km from Patancheru, and 30 km from Sangareddy.',
      features: ['Gated Community', '24/7 Security', 'Clubhouse', 'Swimming Pool', 'Landscaped Gardens', 'Children\'s Play Area'],
      image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80',
    },
    {
      title: 'Royal Oak Estates',
      location: 'Zaheerabad, NIMZ',
      area: '15 Acres',
      units: 'Phase 1',
      description: 'Royal Oak is a 15 acre development located in Zaheerabad, on the Bidar Road, just 3 km from the National Investment Manufacturing Zone (NIMZ). Strategically positioned for growth and connectivity.',
      features: ['Prime Location', 'Near NIMZ', 'Modern Infrastructure', 'Wide Roads', 'Electricity & Water', 'Investment Potential'],
      image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80',
    },
  ];

  return (
    <div className="bg-luxury-bg">
      {/* Premium Hero Section */}
      <section className="relative h-[75vh] flex items-center justify-center overflow-hidden">
        {/* Animated Background */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-fixed"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=1920&q=80')`,
          }}
        />
        
        {/* Luxury Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-br from-luxury-dark/90 via-luxury-primary/80 to-luxury-accent/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/60 via-transparent to-transparent" />
        
        {/* Shimmer Effect */}
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-0 -left-full h-full w-1/2 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 animate-[shimmer_3s_ease-in-out_infinite]" />
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-20 left-10 w-32 h-32 border-2 border-luxury-accent/30 rounded-full animate-pulse" />
        <div className="absolute bottom-20 right-10 w-48 h-48 border-2 border-luxury-accent/20 rounded-full animate-pulse delay-75" />

        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
          <RevealContent delay={0}>
            <span className="inline-block px-6 py-2 border-2 border-luxury-accent/50 rounded-full text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent bg-luxury-dark/30 backdrop-blur-sm">
              Premium Developments
            </span>
          </RevealContent>

          <RevealContent delay={200}>
            <h1 className="font-serif text-6xl lg:text-8xl font-bold text-luxury-white mb-6">
              Our
              <span className="block mt-2 bg-gradient-to-r from-luxury-accent via-yellow-400 to-luxury-accent bg-clip-text text-transparent animate-gradient">
                Signature Projects
              </span>
            </h1>
          </RevealContent>

          <RevealContent delay={400}>
            <div className="flex items-center justify-center gap-4 mb-6">
              <div className="h-px w-24 bg-gradient-to-r from-transparent to-luxury-accent" />
              <div className="w-2 h-2 bg-luxury-accent rounded-full" />
              <div className="h-px w-24 bg-gradient-to-l from-transparent to-luxury-accent" />
            </div>
          </RevealContent>

          <RevealContent delay={600}>
            <p className="text-xl lg:text-2xl text-luxury-white/90 max-w-3xl mx-auto leading-relaxed">
              Crafting exceptional residential spaces that redefine luxury living and investment excellence
            </p>
          </RevealContent>
        </div>

        {/* Bottom Fade */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-luxury-bg to-transparent" />
      </section>

      {/* Projects Section */}
      <section className="py-24 lg:py-32 relative">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, rgb(192, 173, 127) 1px, transparent 0)`,
            backgroundSize: '48px 48px'
          }} />
        </div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          {/* Section Header */}
          <RevealContent>
            <div className="text-center max-w-3xl mx-auto mb-20">
              <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
                Excellence in Real Estate
              </span>
              <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
                Explore Our Portfolio
              </h2>
              <div className="w-24 h-1 bg-luxury-accent mx-auto mb-6" />
              <p className="text-lg text-luxury-primary/80">
                Each project is meticulously designed to offer unparalleled quality and sophistication
              </p>
            </div>
          </RevealContent>

          {/* Projects Grid */}
          {projects.map((project, index) => (
            <div
              key={index}
              className="mb-32 last:mb-0"
            >
              <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center ${
                index % 2 === 1 ? 'lg:grid-flow-dense' : ''
              }`}>
                
                {/* Image Section */}
                <div className={`relative group ${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                  {/* Main Image Container */}
                  <div className="relative overflow-hidden rounded-lg shadow-2xl">
                    {/* RevealImage with Silver Shimmer */}
                    <RevealImage
                      src={project.image}
                      alt={project.title}
                      className="w-full h-[550px]"
                    />
                    
                    {/* Gradient Overlay on Hover */}
                    <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 pointer-events-none" />

                    {/* Premium Badge */}
                    <div className="absolute top-6 left-6 px-4 py-2 bg-luxury-accent/90 backdrop-blur-sm rounded-full z-20">
                      <span className="text-luxury-white text-xs font-semibold uppercase tracking-wider">Premium</span>
                    </div>
                  </div>

                  {/* Decorative Border */}
                  <div className="absolute -bottom-6 -right-6 w-full h-full border-4 border-luxury-accent/30 rounded-lg pointer-events-none transform group-hover:translate-x-2 group-hover:translate-y-2 transition-transform duration-500" />
                  
                  {/* Corner Accents */}
                  <div className="absolute -top-3 -left-3 w-16 h-16 border-t-4 border-l-4 border-luxury-accent" />
                  <div className="absolute -bottom-3 -right-3 w-16 h-16 border-b-4 border-r-4 border-luxury-accent" />
                </div>

                {/* Content Section */}
                <div className={`${index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}`}>
                  {/* Project Number */}
                  <RevealContent delay={0}>
                    <div className="mb-4">
                      <span className="font-serif text-6xl font-bold text-luxury-accent/20">
                        0{index + 1}
                      </span>
                    </div>
                  </RevealContent>

                  {/* Badge */}
                  <RevealContent delay={100}>
                    <div className="inline-block mb-4">
                      <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.15em] text-luxury-accent">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                        Featured Project
                      </span>
                    </div>
                  </RevealContent>

                  {/* Title */}
                  <RevealContent delay={200}>
                    <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-dark mb-4 leading-tight">
                      {project.title}
                    </h2>
                  </RevealContent>

                  {/* Location */}
                  <RevealContent delay={300}>
                    <div className="flex items-start gap-2 text-luxury-primary text-lg mb-8">
                      <svg className="w-6 h-6 text-luxury-accent mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <span>{project.location}</span>
                    </div>
                  </RevealContent>

                  {/* Stats Cards */}
                  <RevealContent delay={400}>
                    <div className="grid grid-cols-2 gap-6 mb-8">
                      <div className="relative p-6 bg-gradient-to-br from-luxury-dark/5 to-luxury-accent/10 rounded-lg border border-luxury-accent/20 hover:border-luxury-accent/40 transition-all duration-300 group/card overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-luxury-accent/0 to-luxury-accent/10 opacity-0 group-hover/card:opacity-100 transition-opacity duration-300" />
                        <div className="relative">
                          <div className="font-serif text-4xl font-bold text-luxury-accent mb-2">{project.area}</div>
                          <div className="text-sm text-luxury-secondary uppercase tracking-wider">Total Area</div>
                        </div>
                      </div>
                      <div className="relative p-6 bg-gradient-to-br from-luxury-dark/5 to-luxury-accent/10 rounded-lg border border-luxury-accent/20 hover:border-luxury-accent/40 transition-all duration-300 group/card overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-luxury-accent/0 to-luxury-accent/10 opacity-0 group-hover/card:opacity-100 transition-opacity duration-300" />
                        <div className="relative">
                          <div className="font-serif text-4xl font-bold text-luxury-accent mb-2">{project.units}</div>
                          <div className="text-sm text-luxury-secondary uppercase tracking-wider">Units</div>
                        </div>
                      </div>
                    </div>
                  </RevealContent>

                  {/* Description */}
                  <RevealContent delay={500}>
                    <p className="text-lg text-luxury-primary leading-relaxed mb-10 border-l-4 border-luxury-accent/30 pl-6">
                      {project.description}
                    </p>
                  </RevealContent>

                  {/* Features */}
                  <RevealContent delay={600}>
                    <div className="mb-10">
                      <h3 className="font-serif text-2xl font-semibold text-luxury-dark mb-6 flex items-center gap-3">
                        <span className="w-12 h-px bg-luxury-accent" />
                        Key Features
                      </h3>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {project.features.map((feature, idx) => (
                          <div
                            key={idx}
                            className="flex items-center gap-3 group/feature"
                          >
                            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-luxury-accent/10 flex items-center justify-center group-hover/feature:bg-luxury-accent/20 transition-colors duration-300">
                              <svg className="w-5 h-5 text-luxury-accent" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                            <span className="text-luxury-primary font-medium group-hover/feature:text-luxury-dark transition-colors duration-300">
                              {feature}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </RevealContent>

                  {/* CTA Button */}
                  <RevealContent delay={700}>
                    <div className="flex gap-4">
                      <a
                        href="/contact"
                        className="relative inline-flex items-center gap-3 px-10 py-5 bg-luxury-accent text-luxury-white font-semibold uppercase tracking-wider rounded-lg overflow-hidden group/btn transition-all duration-300 hover:shadow-2xl hover:shadow-luxury-accent/30"
                      >
                        <span className="absolute inset-0 bg-gradient-to-r from-luxury-accent to-yellow-600 translate-x-full group-hover/btn:translate-x-0 transition-transform duration-500" />
                        <span className="relative">Inquire Now</span>
                        <svg className="relative w-5 h-5 group-hover/btn:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                      </a>
                    </div>
                  </RevealContent>
                </div>
              </div>

              {/* Divider */}
              {index < projects.length - 1 && (
                <div className="mt-32 flex items-center justify-center">
                  <div className="w-full max-w-md h-px bg-gradient-to-r from-transparent via-luxury-accent/30 to-transparent" />
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C0AD7F' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }} />
        </div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <RevealContent delay={0}>
              <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-white mb-6">
                Ready to Find Your Perfect Investment?
              </h2>
            </RevealContent>
            
            <RevealContent delay={200}>
              <p className="text-xl text-luxury-white/90 mb-10 leading-relaxed">
                Connect with our experts to explore these premium developments and discover the ideal property for your portfolio
              </p>
            </RevealContent>
            
            <RevealContent delay={400}>
              <a
                href="/contact"
                className="inline-flex items-center gap-3 px-12 py-6 bg-luxury-white text-luxury-dark font-bold uppercase tracking-wider rounded-lg hover:bg-luxury-accent hover:text-luxury-white transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl"
              >
                Schedule a Consultation
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* Add Custom Styles */}
      <style jsx>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%) skewX(-12deg);
          }
          100% {
            transform: translateX(200%) skewX(-12deg);
          }
        }

        @keyframes gradient {
          0%, 100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }

        .animate-gradient {
          background-size: 200% auto;
          animation: gradient 3s ease infinite;
        }
      `}</style>
    </div>
  );
};

export default Projects;